import { EntityState } from './entities.types';

export const UPDATE_ENTITIES = 'ENTITIES/UPDATE_ENTITIES';
export const EVICT_TENANCY_ORDER = 'ENTITIES/EVICT_TENANCY_ORDER';

export function updateEntities(payload: EntityState) {
  return {
    type: UPDATE_ENTITIES,
    payload,
  } as const;
}

export function evictTenancyOrder(tenancyOrderId: string, entities: Partial<EntityState>) {
  return {
    type: EVICT_TENANCY_ORDER,
    payload: { tenancyOrderId, entities },
  } as const;
}

export type EntityActionTypes = ReturnType<typeof updateEntities> | ReturnType<typeof evictTenancyOrder>;
